import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import ImageBadgeExample from '../examples/ImageBadge';
const ImageBadgeExampleSource = require('!!raw-loader!../examples/ImageBadge');
const ImageBadgeCompositionExampleSource = require('!!raw-loader!../examples/ImageBadgeComposition');
const ImageBadgePage = () => (<div>
        <Helmet title="ImageBadge"/>
        <h3>ImageBadge</h3>
        <p>
            New type of badges, which can only be used in the <code>ImageOverlay</code> component.
        </p>
        <div className="docs-example">
            <ImageBadgeExample />
        </div>
        <pre>
            <PrismCode className="language-jsx">{ImageBadgeExampleSource}</PrismCode>
        </pre>
        <div>
            <h4>Properties</h4>
            <pre>
                <PrismCode className="language-jsx">
                    {`
{
    text: string;
    theme?: 'dark' | 'light';
    icon?: 'education' | 'webinar'; // only icons with prefix Badge<name>.svg
    color?: string;
    hex?: string;
    className?: string;
};
`}
                </PrismCode>
            </pre>
        </div>
        <h4>Usage composition</h4>
        <pre>
            <PrismCode className="language-jsx">{ImageBadgeCompositionExampleSource}</PrismCode>
        </pre>
    </div>);
export default ImageBadgePage;
